/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest(value) {
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequestFromJSON(json) {
    return FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Token': json['Token'],
    };
}
export function FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequestToJSON(json) {
    return FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Token': value['Token'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest.js.map